import React from 'react';
import {
  StyleSheet, View, Text,
  ScrollView,
} from 'react-native';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import Style from '../../style';
import I18n from '../../i18n';
import CTextInput from '../customfields/CTextInput';
import { InvoiceDisputeSchema } from '../../util/validation';
import Button from '../Button';
import { InvoiceStatus } from '../../types/Invoices';

type FormData = yup.InferType<typeof InvoiceDisputeSchema>;

interface Props {
  updateInvoice: (status: InvoiceStatus, reason: string) => void;
  loading?: boolean;
}

const DisputeModal = ({ updateInvoice, loading }: Props) => {
  const methods = useForm<FormData>({
    defaultValues: {
      reason: '',
    },
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    resolver: yupResolver(InvoiceDisputeSchema),
  });

  const onSubmit = methods.handleSubmit((data: FormData) => updateInvoice('disputed', data.reason));

  return (
    <ScrollView showsHorizontalScrollIndicator={false} style={styles.container}>
      <View style={styles.infoContainer}>
        <Text style={styles.header}>{I18n.t('ui.invoices.dispute.title')}</Text>
        <Text style={styles.des}>{I18n.t('ui.invoices.dispute.description')}</Text>
        <FormProvider {...methods}>
          <CTextInput
            name="reason"
            placeholder={I18n.t('ui.invoices.dispute.reasonHint')}
          />
          <View style={styles.buttonPad}>
            <Button
              btnStyleHovered={styles.btnSaveHovered}
              onPress={onSubmit}
              title={I18n.t('ui.buttons.submit')}
              disable={!methods.formState.isDirty}
              loading={loading}
            />
          </View>
        </FormProvider>
      </View>
    </ScrollView>
  );
};

export default DisputeModal;

const styles = StyleSheet.create({
  container: {
    paddingBottom: 30,
    flex: 1,
    paddingHorizontal: 50,
  },
  infoContainer: {
    width: '100%',
    alignItems: 'flex-start',
  },
  header: {
    ...Style.Text.Heading2,
    color: Style.Color.Black,
    textAlign: 'center',
    width: '100%',
    marginBottom: 25,
  },
  des: {
    ...Style.Text.Normal,
    color: Style.Color.Black,
    maxWidth: '100%',
    marginBottom: 24,
  },
  buttonPad: {
    width: '100%',
    height: 40,
    alignSelf: 'center',
    marginBottom: 24,
    marginTop: 24,
  },
  btnSaveHovered: {
    marginLeft: 4,
    backgroundColor: Style.Color.Primary,
  },
});
